interface AttendCalendarProps {
  ym: string; // "YYYY-MM"
  byDay?: Record<string, number>;
  myDays?: string[];
}

const WEEKDAYS = ["일", "월", "화", "수", "목", "금", "토"];

function pad(n: number): string {
  return String(n).padStart(2, "0");
}

// 월간 출근 달력 (by_day 인원수 · my_days 내 출근 표시)
export default function AttendCalendar({ ym, byDay = {}, myDays = [] }: AttendCalendarProps) {
  const [yearStr, monthStr] = ym.split("-");
  const year = Number(yearStr);
  const month = Number(monthStr);

  if (!year || !month) return null;

  const firstWeekday = new Date(year, month - 1, 1).getDay();
  const daysInMonth = new Date(year, month, 0).getDate();
  const mySet = new Set(myDays);

  const cells: (number | null)[] = [];
  for (let i = 0; i < firstWeekday; i += 1) cells.push(null);
  for (let d = 1; d <= daysInMonth; d += 1) cells.push(d);

  return (
    <div>
      <div className="grid grid-cols-7 gap-1.5 mb-1.5">
        {WEEKDAYS.map((w, i) => (
          <div
            key={w}
            className={`text-center text-xs font-semibold py-1 ${
              i === 0 ? "text-accent-600" : i === 6 ? "text-secondary-700" : "text-foreground-500"
            }`}
          >
            {w}
          </div>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-1.5">
        {cells.map((day, idx) => {
          if (day === null) {
            return <div key={`empty-${idx}`} aria-hidden="true"></div>;
          }
          const key = `${year}-${pad(month)}-${pad(day)}`;
          const count = byDay[key] ?? 0;
          const isMine = mySet.has(key);
          const weekday = (firstWeekday + day - 1) % 7;

          return (
            <div
              key={key}
              className={`relative flex aspect-square flex-col items-center justify-center rounded-lg border text-sm transition-colors ${
                isMine
                  ? "border-accent-400 bg-accent-500 text-primary-950 font-bold"
                  : "border-background-200 bg-background-50 text-foreground-700"
              }`}
            >
              <span
                className={
                  weekday === 0 && !isMine
                    ? "text-accent-600"
                    : weekday === 6 && !isMine
                    ? "text-secondary-700"
                    : ""
                }
              >
                {day}
              </span>
              {count > 0 && (
                <span
                  className={`mt-0.5 text-[10px] font-semibold ${
                    isMine ? "text-primary-900" : "text-foreground-400"
                  }`}
                >
                  {count}명
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}